module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Safe and Sound")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("By Caitlin Ricci")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Twenty-one-year-old Mason has to get out of his mother’s house, where her boyfriend subjects him to unwanted advances—and won’t take no for an answer. Since she didn’t believe Mason when he told her about his uncle’s sexual abuse, Mason knows he’s on his own, and it’s up to him to raise the money he needs. He thinks he’s in luck when he takes a modeling job.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Oliver is a photographer, and getting guys and sex has always been easy for him. His current open relationship is no exception: more friendship and fun than anything. But when Oliver meets Mason, he can see the younger man is fragile and desperately in need of help. Before anything can develop between them, Mason needs to free himself of his terrible living situation and start on the road to healing. Oliver wants to stand beside him as he does. What surprises him is the discovery that he might need Mason as much as Mason needs him.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e555470","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0002.vue
// module id = 60
// module chunks = 0